<template>
    <poverty-visualization :charts="charts" :area-chart="areaChart" :line-chart="lineChart" :title="title" :y-domain="yDomain"></poverty-visualization>
</template>
<script>
    import PovertyVisualization from './PovertyVisualization';
    export default{
        data: function(){
            return {
                title: 'Tasa de Participación Laboral',
                yDomain: [0,100],
                charts: [
                    {
                        id: 'zona',
                        title: 'Zonas Urbanas y Rurales',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTd38_p8o7S6qiXVPUmHQVYYyACuce8eFiK0NU1oJpN5sIoedBPv9VYAZhVcJyOzmVYkePcIpFtw8m-/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSN7Gk5QSXFdSw_vLWVwYCvU1QOXQJiw1b4gbcqeEQtwEwMJufhBl4d1jXHljeiiLe2Ibu-O4CGEMzE/pub?gid=0&single=true&output=csv',
                        dimensions: ['region','zona']
                    },
                    {
                        id: 'quintil',
                        title: 'Quintiles',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSQQ1JCeM-KLNYgMsaYfJsNEuA94EnQDv6gCAx0vy3SJqBglYo-pUxAzyG5zgM0yYadWheHpiG_3M1K/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTTC7Ibf3zTMoV7VlrycvXv0LJj-44ggixcROvo_lWXHmb7zuZ0pjZA_sKJfEwm-gL5fMbErjq8rcl6/pub?gid=0&single=true&output=csv',
                        dimensions: ['region','quintil']
                    },
                    {
                        id: 'migrantes',
                        title: 'Migrantes',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRhd1lF2KrsD8oPtUCSUdsMqO-gMbCmvjF25HQz8fmLjDcCyq_C1alTeFCTkGqgkx-W54TD4CJAWOc8/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRAmFrnOvL-izk8J4y0sIvp_WZ2w_lSyk3NFIYAjm0zq77vpW0Ooq7oA4nm6CdeY7ycIP9orq-EL1of/pub?gid=0&single=true&output=csv',
                        dimensions: ['region','migrantes']
                    },
                    {
                        id: 'indigena',
                        title: 'Pueblos Indigenas',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQMCDMIBFNZVkIdyiw8lVW2CauODOUn0kCExDVn6LagQbbBi3fUEChqDnfR1j7buY1pbFODvpMaYia9/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTNX8AnJ7h7xD9TEZcnjpDaxneRoL4DFjGujOY_9bR7Jkrc6aW6RGsbCSSZCErzEOO089NhkSxlazF7/pub?gid=0&single=true&output=csv',
                        dimensions: ['region','indigena']
                    },
                    {
                        id: 'genero',
                        title: 'Genero',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSyLkicY2oG8eH8u4kbmZhie-DEye_ej-aaXRn1aEg-ibbfig9CBrdXxjKkMt_AXO0Ok9oSCaZ8k2lH/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTRDnN98YP8E5vZGshZwRPB22HvmpVkceAo4tqojR3lY6LcEcCMSWImGvT00m6b8qVB9iszkJF46QPd/pub?gid=0&single=true&output=csv',
                        dimensions: ['region','genero']
                    },
                    {
                        id: 'edades',
                        title: 'Rango Etario',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRjX48jVj3tYZfPted2PK0Yxl5baVCfOHB6mUT2vDeWAsOhyuMQQcb3mY6-iVqJi3h51y3qFTJHfsgX/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQtDZ7AEtTXDwtzrJCy--pAIOjzFt_r4tShUxPOgIBhzg6zdwf1fzsmoEcrxEb_4EUktyTsmsYd5LXb/pub?gid=0&single=true&output=csv',
                        dimensions: ['region','edades']
                    },
                ],
                areaChart:{
                    file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRtfF4AvcSMQ1tVnnBRfvUxiYtyOftpNwpkZrMH7i80vEepJPpTY1MU9d7WDlJfpH53q-UFMLWdcu1c/pub?gid=0&single=true&output=csv'
                },
                lineChart:{
                    file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRckadTP95N9KpZxtdmmzDirQzHmrLGEA2O6IcoUAWY1CHpqus2dC1_MAJu_dHgIyGUm4TkV8w8iRij/pub?gid=0&single=true&output=csv'
                }
            }
        },
        components: {
            PovertyVisualization
        }

    }
</script>


// WEBPACK FOOTER //
// src/js/Components/Visualizations/LaborParticipationVisualization.vue